import { createTheme } from "@mui/material/styles";
import { ptBR } from "@mui/material/locale";

// Paleta de cores baseada no projeto CLI
const palette = {
  primary: {
    // Verde extraído da logo da Unicafé (public/assets/Group.svg, fill #00A651).
    // light/dark calculados via MUI augmentColor() para manter contraste coerente.
    main: "#00a651",
    light: "#33b773",
    dark: "#007438",
    contrastText: "#ffffff"
  },
  secondary: {
    main: "#dc004e",
    light: "#ff5983",
    dark: "#9a0036",
    contrastText: "#ffffff"
  },
  error: {
    main: "#f44336",
    light: "#e57373",
    dark: "#d32f2f",
    contrastText: "#ffffff"
  },
  warning: {
    main: "#ff9800",
    light: "#ffb74d",
    dark: "#f57c00",
    contrastText: "#000000"
  },
  info: {
    main: "#2196f3",
    light: "#64b5f6",
    dark: "#1976d2",
    contrastText: "#ffffff"
  },
  success: {
    main: "#4caf50",
    light: "#81c784",
    dark: "#388e3c",
    contrastText: "#ffffff"
  },
  grey: {
    50: "#fafafa",
    100: "#f5f5f5",
    200: "#eeeeee",
    300: "#e0e0e0",
    400: "#bdbdbd",
    500: "#9e9e9e",
    600: "#757575",
    700: "#616161",
    800: "#424242",
    900: "#212121"
  }
};

export const theme = createTheme(
  {
    palette,
    typography: {
      fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
      h1: {
        fontSize: "2.125rem",
        fontWeight: 300,
        lineHeight: 1.167
      },
      h2: {
        fontSize: "1.5rem",
        fontWeight: 400,
        lineHeight: 1.2
      },
      h3: {
        fontSize: "1.25rem",
        fontWeight: 400,
        lineHeight: 1.167
      },
      h4: {
        fontSize: "1.125rem",
        fontWeight: 400,
        lineHeight: 1.235
      },
      h5: {
        fontSize: "1rem",
        fontWeight: 400,
        lineHeight: 1.334
      },
      h6: {
        fontSize: "0.875rem",
        fontWeight: 500,
        lineHeight: 1.6
      },
      subtitle1: {
        fontSize: "1rem",
        fontWeight: 400,
        lineHeight: 1.75
      },
      subtitle2: {
        fontSize: "0.875rem",
        fontWeight: 500,
        lineHeight: 1.57
      },
      body1: {
        fontSize: "1rem",
        fontWeight: 400,
        lineHeight: 1.5
      },
      body2: {
        fontSize: "0.875rem",
        fontWeight: 400,
        lineHeight: 1.43
      },
      button: {
        fontSize: "0.875rem",
        fontWeight: 500,
        lineHeight: 1.75,
        textTransform: "uppercase" as const
      },
      caption: {
        fontSize: "0.75rem",
        fontWeight: 400,
        lineHeight: 1.66
      },
      overline: {
        fontSize: "0.75rem",
        fontWeight: 400,
        lineHeight: 2.66,
        textTransform: "uppercase" as const
      }
    },
    shape: {
      borderRadius: 8
    },
    spacing: 8,
    components: {
      MuiButton: {
        styleOverrides: {
          root: {
            textTransform: "none",
            borderRadius: 8,
            fontWeight: 500,
            padding: "8px 16px"
          },
          contained: {
            boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
            "&:hover": {
              boxShadow: "0 4px 8px rgba(0,0,0,0.15)"
            }
          }
        }
      },
      MuiCard: {
        styleOverrides: {
          root: {
            boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
            borderRadius: 12
          }
        }
      },
      MuiTextField: {
        styleOverrides: {
          root: {
            "& .MuiOutlinedInput-root": {
              borderRadius: 8
            }
          }
        }
      },
      MuiAppBar: {
        styleOverrides: {
          root: {
            boxShadow: "0 2px 4px rgba(0,0,0,0.1)"
          }
        }
      },
      MuiPaper: {
        styleOverrides: {
          root: {
            backgroundImage: "none"
          }
        }
      }
    }
  },
  ptBR
);

export default theme;
